import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
const config = {
  apiKey: "AIzaSyAmAG3tR4NxfG35UGi5UidJ32A9ybyMCrQ",
  authDomain: "hospitality-dashboard.firebaseapp.com",
  databaseURL: "https://hospitality-dashboard.firebaseio.com",
  projectId: "hospitality-dashboard",
  storageBucket: "hospitality-dashboard.appspot.com",
  messagingSenderId: "358447172439",
  appId: "1:358447172439:web:85529fbf1d51de43"
}
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase
const settings = {
}

db.settings(settings)

// firebase collections
const usersCollection = db.collection('users')
const dashboardsCollection = db.collection('dashboards')
const dashboardRevisionsCollection = db.collection('dashboardRevisions')

export {
    db,
    auth,
    currentUser,
    usersCollection,
    dashboardsCollection,
    dashboardRevisionsCollection
  }



// WEBPACK FOOTER //
// ./src/firebaseConfig.js